"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.props = void 0;
var withCompInfo_1 = require("../../../core/withCompInfo");
var utils_1 = require("../common/utils");
exports.props = withCompInfo_1.withCompInfo(['compData', 'compProps', 'compLayout', 'language', 'isMobileView'], function (_a) {
    var compData = _a.compData, compProps = _a.compProps, compLayout = _a.compLayout, language = _a.language, isMobileView = _a.isMobileView;
    return {
        defaultText: compData.defaultText,
        accountToFollow: compData.accountToFollow,
        isMobileView: isMobileView,
        lang: utils_1.getLanguage(compProps.dataLang, language),
        width: compLayout.width || 0,
        height: compLayout.height || 0,
    };
});
//# sourceMappingURL=WTwitterTweet.js.map